import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Mail, Send, Loader2, Headset } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";

export function DemandNudgePanel() {
  const [history, setHistory] = useState([]);
  const [busy, setBusy] = useState(false);

  const load = () => api.get("/platform/demand-nudges").then(({ data }) => setHistory(data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const send = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/platform/demand-nudges/send");
      if (data.sent.length) toast.success(`Nudged ${data.sent.length} dealership${data.sent.length === 1 ? "" : "s"}: ${data.sent.map((s) => s.dealer_name).join(", ")}`);
      else toast.info(data.skipped.length ? `Nothing to send — ${data.skipped.map((s) => `${s.dealer_name} (${s.reason})`).join("; ")}` : "No basic-package dealerships to nudge");
      load();
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="demand-nudge-panel" className="rounded-xl border border-[#2A2E3D] bg-[#12141C] p-5 mb-6">
      <div className="flex flex-col sm:flex-row sm:items-center gap-3 justify-between">
        <div>
          <div className="flex items-center gap-2 font-heading font-bold"><Mail className="h-4 w-4 text-[#0A8CF2]" /> Monthly demand nudges</div>
          <p className="text-xs text-slate-400 mt-1">
            On the 1st, basic-package dealerships whose shoppers asked for a specialist last month get an email with the count and a one-tap upgrade request. Runs once per dealership per month.
          </p>
        </div>
        <Button onClick={send} disabled={busy} data-testid="send-nudges-btn" className="bg-[#0A8CF2] hover:bg-[#3AA3FF] font-semibold h-9 shrink-0">
          {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Send className="mr-1.5 h-3.5 w-3.5" /> Send nudges now</>}
        </Button>
      </div>
      {history.length > 0 && (
        <div className="mt-4 border-t border-slate-800 pt-3 space-y-1.5" data-testid="nudge-history">
          {history.slice(0, 5).map((n) => (
            <div key={n.id} className="flex items-center gap-2 text-xs text-slate-300">
              <Headset className="h-3.5 w-3.5 text-slate-500 shrink-0" />
              <span className="truncate flex-1">
                <span className="font-semibold text-slate-100">{n.dealer_name}</span> · {n.match_requests} request{n.match_requests === 1 ? "" : "s"}, {n.match_taps} tap{n.match_taps === 1 ? "" : "s"} · sent to {n.recipients?.length || 0} admin{n.recipients?.length === 1 ? "" : "s"}
                {n.requested_via_link && <span className="text-emerald-400"> · requested via link</span>}
              </span>
              <span className="text-slate-500 shrink-0">{new Date(n.sent_at).toLocaleDateString()}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
